import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Image, { IImage } from '../Image';
import Button, { ILink } from '../Button';

export interface IVHSCallToActionBarProps extends IBaseElementProps {
	/**
	 * Style
	 */
	style:  'primary' | 'secondary';
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Small Image
	 */
	smallImage?: IImage;
	/**
	 * Large Image
	 */
	largeImage?: IImage;
	/**
	 * Subheading
	 */
	subheading?: string;
	/**
	 * Text
	 */
	text?: string;
	/**
	 * Button
	 */
	button?: ILink;
}

/**
 * CTA Bar
 * @block
 * @icon download
 */
const VHSCallToActionBar: React.FC<IVHSCallToActionBarProps> = ({
	style,
	heading,
	smallImage,
	largeImage,
	subheading,
	text,
	button,
}) => (
	<div
		className={cn(
			'vhs-call-to-action-bar',
			(style === 'secondary') && 'vhs-call-to-action-bar--secondary',
		)}
	>
		<div className="vhs-call-to-action-bar__container">
			{heading && <h2 className="vhs-call-to-action-bar__heading">{heading}</h2>}
			<div className="vhs-call-to-action-bar__wrapper">
				<div className="vhs-call-to-action-bar__images">
					{smallImage?.src && (
						<div className="vhs-call-to-action-bar__image-wrapper vhs-call-to-action-bar__image-wrapper--small">
							<Image
								{...smallImage}
								className="vhs-call-to-action-bar__image vhs-call-to-action-bar__image--small img-fluid"
							/>
						</div>
					)}
					{largeImage?.src && (
						<div className="vhs-call-to-action-bar__image-wrapper vhs-call-to-action-bar__image-wrapper--large">
							<Image
								{...largeImage}
								className="vhs-call-to-action-bar__image vhs-call-to-action-bar__image--large img-fluid"
							/>
						</div>
					)}
				</div>
				<div className="vhs-call-to-action-bar__content">
					{subheading && <h2 className="vhs-call-to-action-bar__subheading">{subheading}</h2>}
					{text && <p className="vhs-call-to-action-bar__text">{text}</p>}
					{button?.label && (
						<Button
							{...button}
							className={cn(
								'vhs-call-to-action-bar__button btn',
								(style !== 'secondary') && 'btn btn-primary',
								(style === 'secondary') && 'btn btn-tertiary',
							)}
						/>
					)}
				</div>
			</div>
		</div>
	</div>
);

export default VHSCallToActionBar;
